import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './lib/store';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Calendar from './pages/Calendar';
import MediaLibrary from './pages/MediaLibrary';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import DailySuggestions from './pages/DailySuggestions';
import Generators from './pages/Generators';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token } = useAuthStore();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/suggestions"
        element={
          <ProtectedRoute>
            <DailySuggestions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/calendar"
        element={
          <ProtectedRoute>
            <Calendar />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/media"
        element={
          <ProtectedRoute>
            <MediaLibrary />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/analytics"
        element={
          <ProtectedRoute>
            <Analytics />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/generators"
        element={
          <ProtectedRoute>
            <Generators />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
